import React from "react";
import { Box, Container, Typography, TextField } from "@mui/material";
import { ReactComponent as arrowright } from "../../../assets/icons/arrowright.svg";

 
const Field = ({ label, required, optional, placeholder, multiline }) => (
  <Box>
    <Typography sx={{ fontSize: "13px", fontWeight: 700, mb: 1 }}>
      {label}
      {required && (
        <Box component="span" sx={{ color: "#e53935", fontWeight: 700, ml: 1 }}>
          必須
        </Box>
      )}
      {optional && (
        <Box
          component="span"
          sx={{ color: "rgba(0,0,0,0.45)", fontWeight: 700, ml: 1 }}
        >
          任意
        </Box>
      )}
    </Typography>
    <TextField
      fullWidth
      placeholder={placeholder}
      variant="outlined"
      multiline={multiline}
      rows={multiline ? 3 : undefined}
      InputProps={{
        sx: {
          fontSize: "13px",
          backgroundColor: "#fff",
          "& fieldset": { borderColor: "rgba(0,0,0,0.15)" },
        },
      }}
    />
  </Box>
);
 
const ContactSection = () => {
  return (
    <Box sx={{ backgroundColor: "#F4F5F6", py: { xs: 6, md: 8 } }}>
      <Container maxWidth={false} sx={{ width: "92%", mx: "auto" }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "340px 1fr" },
            gap: { xs: 5, md: 6 },
          }}
        >
          <Box>
            <Typography
              sx={{
                color: "#FF6000",
                fontWeight: 700,
                fontSize: "13px",
                letterSpacing: "1px",
                mb: 1,
              }}
            >
              CONTACT
            </Typography>
 
            <Typography
              sx={{ fontWeight: 700, fontSize: { xs: "28px", md: "50px" }, mb: 3 }}
            >
              お問い合わせ
            </Typography>
 
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: 700,
                lineHeight: 1.8,
                mb: 2,
              }}
            >
              「まずは話を聞いてみたい」
              <br />
              という段階で構いません。
            </Typography>
 
            <Typography
              sx={{ fontSize: "14px", color: "rgba(0,0,0,0.6)", mb: 3 }}
            >
              1営業日以内にご連絡いたします。
            </Typography>
 
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
              <Typography sx={{ fontSize: "15px", fontWeight: 700 }}>
                ● 相談無料
              </Typography>
              <Typography sx={{ fontSize: "15px", fontWeight: 700 }}>
                ■ デモ対応
              </Typography>
              <Typography sx={{ fontSize: "15px", fontWeight: 700 }}>
                ✓ その場で決める必要はありません
              </Typography>
            </Box>
          </Box>
 
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: "9px",
              border: "1px solid rgba(0,0,0,0.06)",
              p: { xs: 3, md: 4 },
            }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                gap: { xs: 3, sm: 4 },
                mb: 3,
              }}
            >
              <Field label="お名前" required placeholder="例）山田 太郎" />
              <Field
                label="電話番号"
                optional
                placeholder="例）03-1234-5678"
              />
              <Field
                label="会社名"
                required
                placeholder="例）株式会社グローバルジャパン"
              />
              <Field
                label="現在のご利用環境"
                placeholder="SharePoint Online / Teams / Copilot"
              />
              <Field
                label="メールアドレス"
                required
                placeholder="例）taro.yamada@global-japan.co.jp"
              />
              <Field
                label="ご相談内容"
                placeholder="ポータルの課題やご要望をご記入ください"
              />
            </Box>
 
            <Box
              component="button"
              sx={{
                width: "100%",
                border: "none",
                cursor: "pointer",
                backgroundColor: "#FF6000",
                color: "#fff",
                borderRadius: "8px",
                fontWeight: 700,
                fontSize: "15px",
                py: 1.6,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                fontFamily: "inherit",
                position: 'relative',
                "&:hover": { backgroundColor: "#e55500" },
              }}
            >
              無料で相談・デモを申し込む
              <Box
                component={arrowright}
                sx={{
                  width: 20,
                  height: 20,
                  position: 'absolute',
                  right: 0,
                  marginRight: '30px',
                  "& path": { fill: "#fff" },
                }}
              />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
 
export default ContactSection;